<app-dialog
[actions]="[
  { text: 'Cancel', buttonStyle: 'underline', buttonSize: 'action' },
  { text: data.settlement ? 'Confirm' : 'Save', spin: loader, buttonSize: 'action',isDisabled: groupName.invalid}
]"
  (action)="action($event)"
  (close)="close()"
  class="create-group-dialog"
>
  <div class="update-qty">
    <div class="input-container">
      <label for="" class="input-container_label">Group Name</label>
      <input
        class="input-container_input input-container_input--extra-thin"
        type="text"      
        [formControl]="groupName"
      />
    </div>
  </div>
</app-dialog>